import { ArrowDownRight } from "lucide-react";
import { Reveal, Eyebrow, CTAButton } from "./Shared";

const QUESTIONS = [
  "Who are you becoming?",
  "What do you actually want?",
  "Why does it matter beyond the money?",
  "What beliefs are shaping what you allow yourself to receive?",
  "What message are you here to communicate?",
  "Who needs that message?",
  "What offer could make the transformation tangible?",
  "What would become possible if every part of you started moving in the same direction?",
];

export default function Reframe() {
  return (
    <section data-testid="reframe-section" className="relative py-20 sm:py-32">
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <Reveal>
          <Eyebrow>Blueprint is more than a business plan</Eyebrow>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-display font-extrabold uppercase tracking-tight leading-[0.95] text-3xl sm:text-5xl max-w-4xl">
            It is the design beneath the way you think, choose, create, speak{" "}
            <span className="text-lime">+</span>{" "}
            <span className="font-serif italic normal-case font-medium text-lime">sell.</span>
          </h2>
        </Reveal>

        <div className="mt-12 sm:mt-16 grid lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-4">
            <p className="text-sm sm:text-base leading-relaxed text-fog">
              A traditional plan can tell you what to do.{" "}
              <span className="text-cream">BLUEPRINT asks deeper questions:</span>
            </p>
          </Reveal>
          <div className="lg:col-span-8">
            <ul className="border-t border-cream/10">
              {QUESTIONS.map((q, i) => (
                <Reveal key={q} delay={i * 0.05} y={14}>
                  <li className="group flex items-center gap-4 py-4 border-b border-cream/10 transition-colors duration-300 hover:bg-cream/[0.03]">
                    <ArrowDownRight size={16} className="text-lime shrink-0 transition-transform duration-300 group-hover:translate-x-1 group-hover:translate-y-1" />
                    <span className="text-base sm:text-xl text-cream/90 font-light">{q}</span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <Reveal>
        <div className="relative mt-20 sm:mt-32 border-y border-cream/10 bg-coal/60 py-16 sm:py-24 overflow-hidden">
          <span
            aria-hidden="true"
            className="absolute -top-10 left-4 sm:left-12 font-serif text-[16rem] sm:text-[24rem] leading-none text-lime/10 select-none"
          >
            &ldquo;
          </span>
          <div className="relative max-w-6xl mx-auto px-4 sm:px-8">
            <p
              data-testid="reframe-quote"
              className="font-display font-extrabold uppercase tracking-tight leading-[0.95] text-3xl sm:text-5xl lg:text-6xl max-w-5xl"
            >
              Stop trying to force a future your current{" "}
              <span className="font-serif italic normal-case font-medium text-lime">identity</span>{" "}
              doesn&rsquo;t yet know how to hold.
            </p>
            <div className="mt-10 sm:mt-14 grid lg:grid-cols-12 gap-8 items-end">
              <p className="lg:col-span-7 text-sm sm:text-base leading-relaxed text-fog">
                You do not have to fake confidence or pretend you have already arrived.{" "}
                <span className="text-cream">
                  You can intentionally build the beliefs, language, offers, decisions, and small
                  wins that help your new identity become lived — not merely imagined.
                </span>
              </p>
              <div className="lg:col-span-5 flex lg:justify-end">
                <CTAButton testId="reframe-cta-button">Create my blueprint — $111</CTAButton>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
